"use strict";

/**
 * UIHelper - Classe utilitaire pour la manipulation du DOM et l'affichage
 */
export class UIHelper {
  
  /**
   * Affiche un message dans un conteneur spécifique
   */
  static displayMessage(containerId: string, message: string, cssClass: string): void {
    const msg = document.createElement("p");
    msg.innerText = message;
    msg.setAttribute("class", cssClass);
    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = "";
      container.append(msg);
    }
  }

  /**
   * Affiche le bouton de soumission pour le secure input
   */
  static displaySecureInputButton(containerId: string, webInput: any): void {
    let container = document.getElementById(`${containerId}-btn-container`);
    if (!container) {
      container = document.createElement("div");
      container.setAttribute("id", `${containerId}-btn-container`);
      container.setAttribute("class", "buttons");
    } else {
      container.innerHTML = "";
    }
    
    const button = document.createElement("button");
    button.setAttribute("class", "submit-btn");
    button.setAttribute("type", "button");
    button.addEventListener("click", () => {
      webInput.sendSecureInputData();
    });
    button.innerText = "Send";
    container.append(button);
    
    const mainContainer = document.getElementById(containerId);
    if (mainContainer) {
      mainContainer.append(container);
    }
  }

  /**
   * Cache le bouton de soumission du secure input
   */
  static hideSecureInputButton(containerId: string): void {
    const btnContainer = document.getElementById(`${containerId}-btn-container`);
    if (btnContainer) {
      btnContainer.remove();
    }
  }

  /**
   * Toggle l'affichage du champ IP Address
   */
  static toggleIpAddressField(): void {
    const enableIpCheckElement = document.getElementById("enableIpCheck") as HTMLInputElement;
    const enableIpCheck = enableIpCheckElement.checked;
    
    if (enableIpCheck) {
      const ipAddressDiv = document.createElement("div");
      ipAddressDiv.setAttribute("id", "ipAddressDiv");
      const ipAddressLabel = document.createElement("label");
      ipAddressLabel.setAttribute("for", "ipAddress");
      ipAddressLabel.innerText = "Ip Address ";
      const ipAddressInput = document.createElement("input");
      ipAddressInput.setAttribute("id", "ipAddress");
      ipAddressInput.setAttribute("name", "ipAddress");
      ipAddressInput.setAttribute("type", "text");

      ipAddressDiv.appendChild(ipAddressLabel);
      ipAddressDiv.appendChild(ipAddressInput);

      const parent = document.getElementById("enableIpCheck");
      if (parent?.parentNode) {
        parent.parentNode.appendChild(ipAddressDiv);
      }
    } else {
      const ipAddressDiv = document.getElementById("ipAddressDiv");
      if (ipAddressDiv) {
        ipAddressDiv.remove();
      }
    }
  }

  /**
   * Crée un input de type checkbox
   */
  static createCheckBoxInput(parent: HTMLElement, name: string, label: string): void {
    const container = document.createElement("div");
    const labelElement = document.createElement("label");
    labelElement.setAttribute("for", name);
    labelElement.innerText = label;
    const input = document.createElement("input");
    input.setAttribute("id", name);
    input.setAttribute("name", name);
    input.setAttribute("type", "checkbox");
    container.append(labelElement);
    container.append(input);
    parent.append(container);
  }

  /**
   * Crée un input de type radio button
   */
  static createRadioButtonInput(
    parent: HTMLElement, 
    id: string, 
    name: string, 
    label: string, 
    value: string
  ): void {
    const container = document.createElement("div");
    const labelElement = document.createElement("label");
    labelElement.setAttribute("for", name);
    labelElement.innerText = label;
    const input = document.createElement("input");
    input.setAttribute("id", id);
    input.setAttribute("name", name);
    input.setAttribute("type", "radio");
    container.append(labelElement);
    container.append(input);
    parent.append(container);
  }

  /**
   * Crée un input de type number
   */
  static createNumberInput(
    parent: HTMLElement, 
    name: string, 
    label: string, 
    value: number
  ): void {
    const container = document.createElement("div");
    const labelElement = document.createElement("label");
    labelElement.setAttribute("for", name);
    labelElement.innerText = label;
    const input = document.createElement("input");
    input.setAttribute("id", name);
    input.setAttribute("name", name);
    input.setAttribute("type", "number");
    input.setAttribute("value", value.toString());
    container.append(labelElement);
    container.append(input);
    parent.append(container);
  }

  /**
   * Crée un select avec des options
   */
  static createSelectInput(
    parent: HTMLElement, 
    name: string, 
    label: string, 
    options: string[]
  ): void {
    const container = document.createElement("div");
    const labelElement = document.createElement("label");
    labelElement.setAttribute("for", name);
    labelElement.innerText = label;
    const select = document.createElement("select");
    select.setAttribute("id", name);
    select.setAttribute("name", name);
    options.forEach((element) => {
      const opt = document.createElement("option");
      opt.setAttribute("value", element);
      opt.innerHTML = element;
      select.append(opt);
    });
    container.append(labelElement);
    container.append(select);
    parent.append(container);
  }

  /**
   * Vide le contenu d'un conteneur
   */
  static clearContainer(containerId: string): void {
    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = "";
    }
  }
}
